import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactOurExpertsHiddenComponent } from './contact-our-experts-hidden.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { contactOurExpertsOccConfig } from './_core/contact-our-experts.occ';

@NgModule({
  declarations: [ContactOurExpertsHiddenComponent],
  imports: [CommonModule],
  providers: [
    provideConfig(contactOurExpertsOccConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ContactOurExpertsHiddenComponent: {
          component: ContactOurExpertsHiddenComponent,
        },
      },
    }),
  ],
})
export class ContactOurExpertsHiddenModule {}
